export default "__VITE_ASSET__DoBM7inm__"